import { render, staticRenderFns } from "./OfferPartCommission.vue?vue&type=template&id=5255b5ca&scoped=true&"
import script from "./OfferPartCommission.vue?vue&type=script&lang=js&"
export * from "./OfferPartCommission.vue?vue&type=script&lang=js&"
import style0 from "./OfferPartCommission.vue?vue&type=style&index=0&id=5255b5ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255b5ca",
  null
  
)

export default component.exports